import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { InvitationsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createEnrolment = (data, callbackFunction): any => action(types.CREATE_ENROLMENT_REQUESTED, { data, callbackFunction });

export const getInvitation = (personId): any => action(types.GET_INVITATION_REQUESTED, personId);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createEnrolmentPending: (payload): any => action(types.CREATE_ENROLMENT_PENDING, payload),
  createEnrolmentSuccess: (response): any => action(types.CREATE_ENROLMENT_SUCCESS, {
    enrolmentsById: response.entities.enrolments,
    currentEnrolmentId: response.result,
  }),
  createEnrolmentFailed: (error): any => action(types.CREATE_ENROLMENT_FAIL, { backendErrors: error }),
  getInvitationPending: (): any => action(types.GET_INVITATION_PENDING, {}),
  getInvitationSuccess: (response): any => action(types.GET_INVITATION_SUCCESS, {
    invitationsById: response.entities.invitations,
    currentInvitationId: response.result,
  }),
  getInvitationFailed: (error): any => action(types.GET_INVITATION_FAIL, { backendErrors: error }),
};

export default null;
